import {AxisMenuFilterV2} from "../../project/projects/ProjectsListNew";
import ProjectCascadeCard from "../../project/projects/ProjectCascade/ProjectCascadeCard";
import styled from "styled-components";
import AxisCard from "./AxisCard";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {loadAllAxis} from "../../axis/all-axis/axisAction";
import {loadStrategy} from "../strategyAction";
import {loadActions} from "../../action/actionAction";
import {loadUsers} from "../../user/usersAction";
import {loadStakes} from "../../stake/actions/stakeAction";
import ItemLengthCard from "./ItemLengthCard";
import WeatherCard from "./WeatherCard";
import Statistics from "./Statistics";
import {BlueButton} from "../../buttons/ButtonStyles";
import ShareWithTeam from "../../modal/ShareWithTeam";
import StrategyStacks from "../StrategyStacks";
import {getImage, removeDuplicatesInArray, sliceText} from "../../../utils/utils";

const PitchStrategy = () => {
  const dispatch = useDispatch();

  const [openSendPitchModal, setOpenSendPitchModal] = useState(false);
  const { id: currentUserId } = useSelector((state) => state.currentUser);

  const { projects, isLoading } = useSelector((state) => state.projects);
  const { axis } = useSelector((state) => state.axis);
  const { users } = useSelector((state) => state.users);
  const { stakes } = useSelector((state) => state.stakes);
  const {image, name} = useSelector((state) => state.strategy)

  const [data, setData] = useState({
    indicators: [],
    weather: [],
    itemsNumber: [],
    strategicsAxis: [],
  });

  const [filter, setFilter] = useState({
    axisId: [],
  });

  useEffect(() => {
    Promise.all([
      dispatch(loadStrategy()),
      dispatch(loadAllAxis()),
      dispatch(loadActions(currentUserId)),
      dispatch(loadUsers()),
      dispatch(loadStakes()),
    ]).then(() => console.log("Data loaded"));
  }, [currentUserId, dispatch]);
  const displayStakesAdvancement = (stake) => {
    let advancement = 0
      if (stake.projects){
        stake.projects.map(p => {
          advancement = (advancement + p.advancement);
        })

       advancement = stake.projects.length != 0 ? (advancement / stake.projects.length) : 0
      }
    return advancement.toFixed(0);
  }
  useEffect(() => {
    if (!isLoading && projects.length > 0) {
      const strategicsAxis = axis
        .filter((a) => a.isStrategic)
        .filter(
          (a) => filter.axisId.length === 0 || filter.axisId.includes(a.id)
        );
      const strategicStakes = stakes
        .filter((s) => s.isStrategic)
        .filter(
          (s) => filter.axisId.length === 0 || filter.axisId.includes(s.axisId)
        );
      const getStrategicProjectsFromAxis = () => {
        let strategicProjectsFromAxis = []
        let res = []
            strategicsAxis.map(a => {
          return a.stakes.map(s => {
            return s.projects.map(p => {
              return strategicProjectsFromAxis.push(p.id)
            })
          })
        })
        projects.map((p) => {
          return strategicProjectsFromAxis.includes(p.id)? res.push(p) : ""
        })
        return res
      }

      const strategicProjectsFromAxis = getStrategicProjectsFromAxis()
      const strategicsActions = [
        ...strategicProjectsFromAxis.map((p) => p.actions),
      ].flat(1);

      const numberOfPilots = users.filter((user) => user.isPilot).length;
      const numberOfStrategicPilots = () => {
        let strategicPilots = strategicProjectsFromAxis.map((p) => {
          return p.pilot;
        });
        return removeDuplicatesInArray(strategicPilots).length;
      };

      const numberOfProjectsPerPilot =
        numberOfPilots === 0 ? 0 : (strategicProjectsFromAxis.length / numberOfStrategicPilots()).toFixed(2);
      const indicators = [
        {
          label: strategicsAxis.length > 1 ? "Axes" : "Axe",
          values: strategicsAxis.length,
          id: "basic",
          key: "axisKey",
        },
        {
          label: users.length > 1 ? "Utilisateurs" : "Utilisateur",
          values: users.length,
          id: "basic",
          key: "usersKey",
        },
        {
          label: strategicStakes.length > 1 ? "Enjeux" : "Enjeu",
          values: strategicStakes.length,
          id: "basic",
          key: "stakesKey",
        },
        {
          label: numberOfStrategicPilots() > 1 ? "Pilotes" : "Pilote",
          values: numberOfStrategicPilots(),
          id: "basic",
          key: "pilotsKey",
        },
        {
          label: strategicProjectsFromAxis.length > 1 ? "Projets" : "Projet",
          values: strategicProjectsFromAxis.length,
          id: "basic",
          key: "projectsKey",
        },
        {
          label: strategicsActions.length > 1 ? "Actions" : "Action",
          values: strategicsActions.length,
          id: "basic",
          key: "actionsKey",
        },
      ];
      const weather = [
        {
          weather: "sunny",
          value: strategicProjectsFromAxis.filter((p) => p.weather === "sunny").length,
        },
        {
          weather: "cloudy",
          value: strategicProjectsFromAxis.filter((p) => p.weather === "cloudy").length,
        },
        {
          weather: "stormy",
          value: strategicProjectsFromAxis.filter((p) => p.weather === "stormy").length,
        },
        {
          weather: "rainy",
          value: strategicProjectsFromAxis.filter((p) => p.weather === "rainy").length,
        },
        {
          weather: "question",
          value: strategicProjectsFromAxis.filter((p) => p.weather === null).length,
        },
      ];

      const lateProjects = strategicProjectsFromAxis.filter(
        (p) =>
          !!p.endDate &&
          new Date(p.endDate) <= new Date() &&
          p.advancement < 100
      ).length;

      const completedProjects = strategicProjectsFromAxis.filter(
        (p) => p.advancement === 100
      ).length;

      const lateActions = strategicsActions.filter(
        (a) =>
          !!a.deadline &&
          new Date(a.deadline) <= new Date() &&
          a.advancement < 100
      ).length;

      const completeActions = strategicsActions.filter(
        (a) => a.advancement === 100
      ).length;

      const itemsNumber = [
        {
          label: completedProjects > 1 ? "Projets terminés" : "Projet terminé",
          values: completedProjects,
          id: "green",
        },
        {
          label: lateProjects > 1 ? `Projets en retard` : `Projet en retard`,
          values: lateProjects,
          id: "red",
        },
        {
          label:
            numberOfProjectsPerPilot > 1
              ? `Projets / pilote`
              : `Projet / pilote`,
          values: numberOfProjectsPerPilot,
          id: "yellow",
        },
        {
          label: completeActions > 1 ? "Actions terminées" : "Action terminée",
          values: completeActions,
          id: "green",
        },
        {
          label: lateActions > 1 ? "Actions en retard" : "Action en retard",
          values: lateActions,
          id: "red",
        },
        {
          label: strategicsActions.length ? "Actions" : "Action",
          values: strategicsActions.length,
          id: "yellow",
        },
      ];
      setData({ indicators, itemsNumber, weather, strategicsAxis });
    }
  }, [axis, filter.axisId, isLoading, projects, stakes,users]);

  return (
    <Container>
      <FirstSection>
        <h2> Pitch Stratégie </h2>
        <SendStrategyButton onClick={() => setOpenSendPitchModal(true)}>
          <p>Partager le pitch Stratégie</p>
        </SendStrategyButton>
      </FirstSection>
      <PrintIMG>
        <img src={getImage(image)} alt=""/>
      </PrintIMG>
      <PrintHeader>
        <h2>Rapport du {new Date().toLocaleDateString("fr-FR")}</h2>
      </PrintHeader>
      <PrintHeader>
        <h2>{name}</h2>
      </PrintHeader>
      <SectionValuesVisionAmbition>
        <StrategyStacks isInteractive={false} />
      </SectionValuesVisionAmbition>
      <PrintHeader>
        <h2>Indicateurs</h2>
      </PrintHeader>
      <Div>
        <Wrapper>
          <Indicators>
            {data.indicators.map((i) => (
                <ItemLengthCard
                    key={i.key}
                    id={i.id}
                    label={i.label}
                    value={i.values}
                />
            ))}
          </Indicators>
          <SectionWeathers>
            {data.weather.map((w) => (
                <WeatherCard
                    key={w.weather}
                    weather={w.weather}
                    value={w.value}
                />
            ))}
          </SectionWeathers>
        </Wrapper>
        <SectionIndicatorsState>
          {data.itemsNumber.map((i) => (
              <ItemLengthCard
                  key={i.label}
                  id={i.id}
                  label={i.label}
                  value={i.values}
              />
          ))}
        </SectionIndicatorsState>
      </Div>

      <AxisMenuFilterV2
        filter={filter}
        onChange={(values) =>
          setFilter((prev) => ({ ...prev, axisId: values }))
        }
        displayGrid
        onlyStrategic
      />
      <SectionAxis>
        {data.strategicsAxis.map((axis) => (
          <SectionAxis>
            <AxisCard
              key={axis.id}
              name={axis.name}
              picture={axis.image}
              stakes={axis.stakes}
              advancement={axis.stakeAdvancementAVG}
            />
            <StakeAdvancement>
              {
                axis.stakes.length > 0 ?
                    axis.stakes.map(s => {
                      return <p> {sliceText(s.name, 50)} : {displayStakesAdvancement(s)} %</p>
                    })
                    :
                    <p> Aucun enjeu pour le moment </p>
              }
            </StakeAdvancement>
            <List>
            {projects.filter((p) => p.axisId === axis.id).length === 0 && (
                <h2>Pas de projet pour cet axe</h2>
              )}

              {projects
                .filter((p) => p.axisId === axis.id)
                .map((p) => (
                  <ProjectCascadeCard key={p.id} project={p} hideActions users={users} />
                ))}
            </List>
          </SectionAxis>
        ))}
      </SectionAxis>
      <PrintHeader>
        <h2>Statistiques</h2>
      </PrintHeader>
      <Statistics
        projects={projects
          .filter((p) => p.isStrategic)
          .filter(
            (p) =>
              filter.axisId.length === 0 ||
              filter.axisId.includes(p.stake?.axisId)
          )}
      />
      {openSendPitchModal && (
        <ShareWithTeam
          setIsOpenShareWithModal={setOpenSendPitchModal}
          label={"le pitch stratégie"}
          name={"strategy"}
        />
      )}
    </Container>
  );
};

const SendStrategyButton = styled(BlueButton)`
  width: 15rem;
  padding: 0.5rem;
  align-self: center;
`;
const FirstSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media print {
    display: none;
  }
`;
const Container = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: 3rem;
  padding: 0 2rem;
`;

const PrintHeader = styled.div`
  display: none;
  @media print {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1vh;
  }
`;

const PrintIMG = styled.div`
  display: none;
  @media print {
    display: block;
  }
`;

const SectionValuesVisionAmbition = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
  }
  @media print {
    width: 100%;
    justify-content: center;
    align-items: stretch;
    overflow: hidden;
    page-break-after: always;
    gap: 32px;
  }
`;
const SectionAxis = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: row;
  gap: 1rem;
  flex-wrap: wrap;
  @media print {
    page-break-after: always;
    page-break-before: always;
  }
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  @media (min-width: 768px) {
    flex-direction: row;
  }
  @media print {
    flex-direction: row;
  }
`;

const Div = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  @media (min-width: 1224px) {
    flex-direction: row;
    align-items: flex-start;
  }
  @media print {
    align-items: flex-start;
    flex-direction: row;
  }
`;
const Indicators = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  @media print {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
  }
`;

const SectionIndicatorsState = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media print {
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
  }
`;
const SectionWeathers = styled.section`
  h2 {
    color: var(--color-black);
  }

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  @media print {
    gap: 4px;
    grid-template-columns: repeat(2, 1fr);
  }
`;

const List = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1.5rem;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 350px);
  }
  @media (min-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`;

const StakeAdvancement = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  padding-top: 1rem;
  gap: 0.2rem;
  width: 400px;
  p {
    overflow: hidden;
    font-size: 14px;
    font-weight: bolder;
  }
`

export default PitchStrategy;
